/**
 * "Mod" is Command on Apple platforms and Control everywhere else. The shell
 * accepts either modifier at runtime — matching on both is friendlier than
 * sniffing the platform and being wrong — while labels are platform-specific.
 */
export function isApplePlatform(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Mac|iPhone|iPad|iPod/u.test(navigator.userAgent);
}

export function modLabel(): string {
  return isApplePlatform() ? "⌘" : "Ctrl";
}

export function altLabel(): string {
  return isApplePlatform() ? "⌥" : "Alt";
}

export function hasMod(event: Pick<KeyboardEvent, "metaKey" | "ctrlKey">): boolean {
  return event.metaKey || event.ctrlKey;
}

/** True when a keystroke is being typed into a field and should not be a shortcut. */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}
